export default __webpack_public_path__ + "static/media/cross.91632e58.svg";